<template>
    <div>
        <highcharts class="chart h-100 min-height-300" :constructor-type="'chart'" :options="chartOptions"></highcharts>
    </div>
</template>

<script>
export default {
    props: {
        chartData: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            chartOptions: {
                ...{
                    chart: {
                        type: 'bar'
                    },
                    title: {
                        text: "Processing errors",
                        align: "left",
                    },
                    yAxis: {
                        tickInterval: 1,
                        title: null,
                    },
                },
                ...this.chartData
            }
        };
    },
};
</script>